import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource } from '@angular/material';
import { College } from 'src/app/features/requets/shared/model/college.model';

@Component({
  selector: 'app-select-collage-dialog',
  templateUrl: './select-collage-dialog.component.html',
  styleUrls: ['./select-collage-dialog.component.scss']
})
export class SelectCollageDialogComponent implements OnInit {

  displayedColumns = ['departamento', 'ciudad', 'institucion'];
  selectedRowIndex = -1;
  SelectCollege: College;
  dataSource;


  tittle: String;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SelectCollageDialogComponent>) {
    this.dataSource = new MatTableDataSource<College>(data.collages);

   }

  ngOnInit() {

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toUpperCase();
  }

  close() {
    this.dialogRef.close(null);
  }

  highlight(row) {
    this.selectedRowIndex = row.codigo;
    this.SelectCollege =  row;
 }

 sendSelect() {
  const data = { index: this.data.index , college: this.SelectCollege };
  this.dialogRef.close(data);
 }

}
